<div class="wrapper-content game-wrapper-full"
[class.color-1]="url=='incendios-forestales'"
[class.color-2]="url=='humedales'"
[style.background]="(url=='incendios-forestales')?'url('+'/assets/games/fuego-04.jpg'+')':'url('+'/assets/games/humedales-03.jpg'+')'">

  <div class="game-header fullwidth">
    <h5 class="legend">{{url}} / Jugar ahora</h5>
    <h1 class="title">{{title}}</h1>
    <a class="btn-back" (click)="route.goTo('juego-inicio/'+url)" style="text-decoration: none;">
      <svg xmlns="http://www.w3.org/2000/svg" width="85" height="85" viewBox="0 0 85 85">
        <g id="Grupo_75" data-name="Grupo 75" transform="translate(-1142 -30)">
          <rect id="Rectángulo_145" data-name="Rectángulo 145" width="85" height="85" transform="translate(1142 30)" />
          <g id="Grupo_73" data-name="Grupo 73" transform="translate(1164.95 52.95)">
            <rect id="Rectángulo_3" data-name="Rectángulo 3" width="51" height="5.1"
              transform="translate(0 36.062) rotate(-45)" fill="#fff" />
            <rect id="Rectángulo_141" data-name="Rectángulo 141" width="51" height="5.1"
              transform="translate(3.606 0) rotate(45)" fill="#fff" />
          </g>
        </g>
      </svg>


    </a>
  </div>

  <a (click)="route.goTo('juego-trivia/'+url)" *ngIf="trivias  && gameStatus=='stop'" class="btn-back-2"
    style="z-index: 3">
    <svg xmlns="http://www.w3.org/2000/svg" width="85" height="85" viewBox="0 0 85 85">
      <g id="Grupo_87" data-name="Grupo 87" transform="translate(-1142 -30)">
        <rect id="Rectángulo_145" data-name="Rectángulo 145" width="85" height="85" transform="translate(1142 30)" />
        <path id="Trazado_35" data-name="Trazado 35" d="M2420,308.187l21.85,21.85,21.85-21.85"
          transform="translate(1503.537 -2369.5) rotate(90)" fill="none" stroke="#fff" stroke-width="7" />
      </g>
    </svg>
  </a>

  <div class="container-fluid game-content transparent" style="width:100%">

    <div class="container-fluid wrapper-content wow fadeInUp" *ngIf="trivias  && gameStatus=='stop'" data-wow-delay="1s">
      <svg  *ngIf="url==='incendios-forestales'" style="display: block; margin: auto; transform:scale(1.1)" xmlns="http://www.w3.org/2000/svg" width="140" height="140"
        viewBox="0 0 140 140">
        <g id="Grupo_98" data-name="Grupo 98" transform="translate(-140.83 -207.333)">
          <path id="Trazado_38" data-name="Trazado 38"
            d="M204.769,230.427c16.224,9.523,24.51,23.392,24.5,42.023l1.235.4,5.469-8.961c10.315,14.269,16.045,40.264-2.66,55.21a78.311,78.311,0,0,1-7.29,4.73c1.749-4.266,4.242-8.62,5.265-13.283,1.263-5.754-1.142-11.055-4.653-15.767-2.062-2.769-4.594-5.315-6.1-8.348-2.24-4.524-3.756-9.39-5.629-14.238-9.583,7.722-11.728,18.52-10.968,30.8-5.44-2.476-5.888-6.976-6.454-11.434-7.968,7.634-7.6,22.68.72,31.913-4.165-.617-10.169-5.027-14.03-10.307-8.675-11.862-8.667-27.688.215-40.6,2.856-4.154,6.092-8.063,9.222-12.036,6.448-8.185,10.252-17.3,10.425-27.729a8.521,8.521,0,0,1,.14-1.459C204.219,231.128,204.424,230.946,204.769,230.427Z"
            transform="translate(-0.797 0.204)" fill="#fff" />
          <g id="Grupo_89" data-name="Grupo 89" transform="translate(140.83 207.333)">
            <path id="Trazado_39" data-name="Trazado 39"
              d="M210.83,347.333a70,70,0,1,1,70-70A70.079,70.079,0,0,1,210.83,347.333Zm0-133.05a63.05,63.05,0,1,0,63.05,63.05A63.121,63.121,0,0,0,210.83,214.283Z"
              transform="translate(-140.83 -207.333)" fill="#fff" />
          </g>
        </g>
      </svg>

      <svg  *ngIf="url==='humedales'"style="display: block; margin: auto;"  xmlns="http://www.w3.org/2000/svg" width="141" height="141" viewBox="0 0 141 141">
        <g id="Grupo_114" data-name="Grupo 114" transform="translate(-304.83 -207)">
          <g id="Grupo_114-2" data-name="Grupo 114">
            <path id="Trazado_49" data-name="Trazado 49" d="M375.33,348a70.5,70.5,0,1,1,70.5-70.5A70.58,70.58,0,0,1,375.33,348Zm0-134a63.5,63.5,0,1,0,63.5,63.5A63.572,63.572,0,0,0,375.33,214Z" fill="#fff"/>
          </g>
          <path id="Trazado_50" data-name="Trazado 50" d="M373.991,326c-2-.252-4.039-.347-6-.782a35.978,35.978,0,0,1-25.2-19.247,35.058,35.058,0,0,1-3.752-12.415,42.6,42.6,0,0,1,2.15-18.1A82.393,82.393,0,0,1,352.86,253.29a145.672,145.672,0,0,1,20.663-23.075c1.747-1.6,1.774-1.627,3.521-.043a152.378,152.378,0,0,1,13.992,14.45,117.452,117.452,0,0,1,12.715,18,64.294,64.294,0,0,1,7.025,17.671,39.121,39.121,0,0,1,.824,13.368,36.638,36.638,0,0,1-29.5,31.7c-1.787.36-3.631.437-5.449.644Zm19.7-56.44c1.311,18.967-5.93,33.581-21.7,44.039.8.077,1.548.194,2.3.215a24.375,24.375,0,0,0,11.974-2.6A23.979,23.979,0,0,0,397,300.491a24.561,24.561,0,0,0,2.3-15.248A49.976,49.976,0,0,0,393.7,269.56Z" fill="#fff"/>
        </g>
      </svg>

      <h1 class="trivia-title" *ngIf="category">
        {{title}}
      </h1>

      <a style="max-height: 60px;
      min-width: 250px;    position: relative;
    bottom: 30px;
      margin: auto;" (click)="play()" class="btn-theme ts-background-4">Empezar</a>
    </div>

    <!--  <div class="col-12" *ngIf="trivias  && gameStatus=='stop'">
      <a class="btn-theme th-back-4 centered" (click)="play()">Comenzar</a>
    </div> -->

    <div style="width: 100%" *ngIf="trivias && (gameStatus=='play' || gameStatus=='pause')">
      <div class="col-12" *ngFor="let t of trivias; let i = index" [hidden]="i!=current-1">
        <p class="game-instruction text-center" >PREGUNTA {{current}} DE {{limit}}</p>
        <h4 class="game-title light" (click)="play()">{{(t.question)?t.question:''}}</h4>
      </div>
      <div class="col-12 flex-row" style="padding: 0;" *ngFor="let t of trivias; let i = index" [hidden]="i!=current-1">
        <div class="stage ts-hover-background-3"  (click)="choose(t,1)" [class.paused]="gameStatus=='pause'" [class.dismissed]="selected==2">
          <h5 class="stage-option" [innerHTML]="t.option_1"><span class="question"></span></h5>
        </div>
        <div class="stage ts-hover-background-3" (click)="choose(t,2)" [class.paused]="gameStatus=='pause'" [class.dismissed]="selected==1">
          <h5 class="stage-option"  [innerHTML]="t.option_2"><span class="question"></span></h5>
        </div>
      </div>
    </div>


    <div class="col-12" *ngIf="trivias  && gameStatus=='finished'">
      <svg *ngIf="url==='incendios-forestales'" xmlns="http://www.w3.org/2000/svg" width="87" height="87"
      viewBox="0 0 87 87">
      <g id="Grupo_113" data-name="Grupo 113" transform="translate(-137 -299)">
        <path id="Trazado_47" data-name="Trazado 47"
          d="M171.413,52.333A30.583,30.583,0,1,0,202,82.916,30.618,30.618,0,0,0,171.413,52.333Zm9.324,49.066a33.589,33.589,0,0,1-3.135,2.083,37.064,37.064,0,0,0,2.264-5.849c.543-2.534-.491-4.868-2-6.943a25.767,25.767,0,0,1-2.621-3.676c-.963-1.992-1.615-4.135-2.421-6.27-4.121,3.4-5.043,8.155-4.716,13.562-2.339-1.09-2.532-3.072-2.775-5.035-3.426,3.362-3.269,9.987.31,14.053-1.791-.272-4.373-2.214-6.033-4.539a15.529,15.529,0,0,1,.092-17.879c1.228-1.829,2.62-3.551,3.965-5.3A20.166,20.166,0,0,0,168.15,63.4a3.838,3.838,0,0,1,.06-.642c.017-.094.105-.174.254-.4,6.976,4.194,10.54,10.3,10.535,18.5l.531.178,2.352-3.946C186.317,83.371,188.781,94.818,180.737,101.4Z"
          transform="translate(9.003 259.583)" fill="#fff" />
      </g>
    </svg>
    <svg *ngIf="url==='humedales'" xmlns="http://www.w3.org/2000/svg" width="141" height="141" viewBox="0 0 141 141">
      <g id="Grupo_114" data-name="Grupo 114" transform="translate(-304.83 -207)">
        <g id="Grupo_114-2" data-name="Grupo 114">
          <path id="Trazado_49" data-name="Trazado 49"
            d="M375.33,348a70.5,70.5,0,1,1,70.5-70.5A70.58,70.58,0,0,1,375.33,348Zm0-134a63.5,63.5,0,1,0,63.5,63.5A63.572,63.572,0,0,0,375.33,214Z"
            fill="#fff" />
        </g>
        <path id="Trazado_50" data-name="Trazado 50"
          d="M373.991,326c-2-.252-4.039-.347-6-.782a35.978,35.978,0,0,1-25.2-19.247,35.058,35.058,0,0,1-3.752-12.415,42.6,42.6,0,0,1,2.15-18.1A82.393,82.393,0,0,1,352.86,253.29a145.672,145.672,0,0,1,20.663-23.075c1.747-1.6,1.774-1.627,3.521-.043a152.378,152.378,0,0,1,13.992,14.45,117.452,117.452,0,0,1,12.715,18,64.294,64.294,0,0,1,7.025,17.671,39.121,39.121,0,0,1,.824,13.368,36.638,36.638,0,0,1-29.5,31.7c-1.787.36-3.631.437-5.449.644Zm19.7-56.44c1.311,18.967-5.93,33.581-21.7,44.039.8.077,1.548.194,2.3.215a24.375,24.375,0,0,0,11.974-2.6A23.979,23.979,0,0,0,397,300.491a24.561,24.561,0,0,0,2.3-15.248A49.976,49.976,0,0,0,393.7,269.56Z"
          fill="#fff" />
      </g>
    </svg>

      <h1 class="text-center m-b0" style="color: white;">Genial, ya terminamos...</h1>
      <h3 class="text-center m-b0" style="color: white; margin-top: 150px;">
        Acertaste en {{score}} de
        {{this.limit}} preguntas</h3>
      <img src="../../assets/ICONOS-ILUSTRADOS/trofeo.png" style="margin: auto; max-height: 200px; display: block;"
        alt="">
        <div class=col-12 style="display: flex;
        justify-content: space-evenly;
        align-items: center;
        margin-top: 20px;">
          <a style="margin:0 10px" class="btn-theme ts-background-4 centered">Compartir</a>
          <a style="margin:0 10px" class="btn-theme ts-background-4 centered" (click)="restart()">Reiniciar</a>
        </div>


        <div class="wrapper-confetti">
          <div class="confetti-149"></div>
          <div class="confetti-148"></div>
          <div class="confetti-147"></div>
          <div class="confetti-146"></div>
          <div class="confetti-145"></div>
          <div class="confetti-144"></div>
          <div class="confetti-143"></div>
          <div class="confetti-142"></div>
          <div class="confetti-141"></div>
          <div class="confetti-140"></div>
          <div class="confetti-139"></div>
          <div class="confetti-138"></div>
          <div class="confetti-137"></div>
          <div class="confetti-136"></div>
          <div class="confetti-135"></div>
          <div class="confetti-134"></div>
          <div class="confetti-133"></div>
          <div class="confetti-132"></div>
          <div class="confetti-131"></div>
          <div class="confetti-130"></div>
          <div class="confetti-129"></div>
          <div class="confetti-128"></div>
          <div class="confetti-127"></div>
          <div class="confetti-126"></div>
          <div class="confetti-125"></div>
          <div class="confetti-124"></div>
          <div class="confetti-123"></div>
          <div class="confetti-122"></div>
          <div class="confetti-121"></div>
          <div class="confetti-120"></div>
          <div class="confetti-119"></div>
          <div class="confetti-118"></div>
          <div class="confetti-117"></div>
          <div class="confetti-116"></div>
          <div class="confetti-115"></div>
          <div class="confetti-114"></div>
          <div class="confetti-113"></div>
          <div class="confetti-112"></div>
          <div class="confetti-111"></div>
          <div class="confetti-110"></div>
          <div class="confetti-109"></div>
          <div class="confetti-108"></div>
          <div class="confetti-107"></div>
          <div class="confetti-106"></div>
          <div class="confetti-105"></div>
          <div class="confetti-104"></div>
          <div class="confetti-103"></div>
          <div class="confetti-102"></div>
          <div class="confetti-101"></div>
          <div class="confetti-100"></div>
          <div class="confetti-99"></div>
          <div class="confetti-98"></div>
          <div class="confetti-97"></div>
          <div class="confetti-96"></div>
          <div class="confetti-95"></div>
          <div class="confetti-94"></div>
          <div class="confetti-93"></div>
          <div class="confetti-92"></div>
          <div class="confetti-91"></div>
          <div class="confetti-90"></div>
          <div class="confetti-89"></div>
          <div class="confetti-88"></div>
          <div class="confetti-87"></div>
          <div class="confetti-86"></div>
          <div class="confetti-85"></div>
          <div class="confetti-84"></div>
          <div class="confetti-83"></div>
          <div class="confetti-82"></div>
          <div class="confetti-81"></div>
          <div class="confetti-80"></div>
          <div class="confetti-79"></div>
          <div class="confetti-78"></div>
          <div class="confetti-77"></div>
          <div class="confetti-76"></div>
          <div class="confetti-75"></div>
          <div class="confetti-74"></div>
          <div class="confetti-73"></div>
          <div class="confetti-72"></div>
          <div class="confetti-71"></div>
          <div class="confetti-70"></div>
          <div class="confetti-69"></div>
          <div class="confetti-68"></div>
          <div class="confetti-67"></div>
          <div class="confetti-66"></div>
          <div class="confetti-65"></div>
          <div class="confetti-64"></div>
          <div class="confetti-63"></div>
          <div class="confetti-62"></div>
          <div class="confetti-61"></div>
          <div class="confetti-60"></div>
          <div class="confetti-59"></div>
          <div class="confetti-58"></div>
          <div class="confetti-57"></div>
          <div class="confetti-56"></div>
          <div class="confetti-55"></div>
          <div class="confetti-54"></div>
          <div class="confetti-53"></div>
          <div class="confetti-52"></div>
          <div class="confetti-51"></div>
          <div class="confetti-50"></div>
          <div class="confetti-49"></div>
          <div class="confetti-48"></div>
          <div class="confetti-47"></div>
          <div class="confetti-46"></div>
          <div class="confetti-45"></div>
          <div class="confetti-44"></div>
          <div class="confetti-43"></div>
          <div class="confetti-42"></div>
          <div class="confetti-41"></div>
          <div class="confetti-40"></div>
          <div class="confetti-39"></div>
          <div class="confetti-38"></div>
          <div class="confetti-37"></div>
          <div class="confetti-36"></div>
          <div class="confetti-35"></div>
          <div class="confetti-34"></div>
          <div class="confetti-33"></div>
          <div class="confetti-32"></div>
          <div class="confetti-31"></div>
          <div class="confetti-30"></div>
          <div class="confetti-29"></div>
          <div class="confetti-28"></div>
          <div class="confetti-27"></div>
          <div class="confetti-26"></div>
          <div class="confetti-25"></div>
          <div class="confetti-24"></div>
          <div class="confetti-23"></div>
          <div class="confetti-22"></div>
          <div class="confetti-21"></div>
          <div class="confetti-20"></div>
          <div class="confetti-19"></div>
          <div class="confetti-18"></div>
          <div class="confetti-17"></div>
          <div class="confetti-16"></div>
          <div class="confetti-15"></div>
          <div class="confetti-14"></div>
          <div class="confetti-13"></div>
          <div class="confetti-12"></div>
          <div class="confetti-11"></div>
          <div class="confetti-10"></div>
          <div class="confetti-9"></div>
          <div class="confetti-8"></div>
          <div class="confetti-7"></div>
          <div class="confetti-6"></div>
          <div class="confetti-5"></div>
          <div class="confetti-4"></div>
          <div class="confetti-3"></div>
          <div class="confetti-2"></div>
          <div class="confetti-1"></div>
          <div class="confetti-0"></div>
        </div>

    </div>

    <!-- <div class="btn-circle bot-left" style="border: 5px solid;" *ngIf="trivias && (gameStatus=='play' || gameStatus=='pause')">
      <div class="count flex" style="color: #656565;">{{current}}</div>
    </div> -->
    <div class="btn-circle bot-right circle" *ngIf="trivias && (gameStatus=='play' || gameStatus=='pause')">
      <div class="count">{{timeLeft}}</div>
      <div class="l-half" *ngIf="gameStatus=='play'"></div>
      <div class="r-half" *ngIf="gameStatus=='play'"></div>
    </div>
  </div>
  <!--
  <div class="col-12" *ngIf="trivias && gameStatus!='finished' ">
    <h2 class="centered" style="color:white;margin-top: 100px;text-shadow: 2px 3px 3px #00000029;">{{title}}</h2>
  </div>
-->



</div>

<ng-template #content let-modal>
<!--   <a (click)="modal.dismiss()" class="btn-circle top-right">
    <svg xmlns="http://www.w3.org/2000/svg" width="85" height="85" viewBox="0 0 85 85">
      <g id="Grupo_75" data-name="Grupo 75" transform="translate(-1142 -30)">
        <rect id="Rectángulo_145" data-name="Rectángulo 145" width="85" height="85" transform="translate(1142 30)" />
        <g id="Grupo_73" data-name="Grupo 73" transform="translate(1164.95 52.95)">
          <rect id="Rectángulo_3" data-name="Rectángulo 3" width="51" height="5.1"
            transform="translate(0 36.062) rotate(-45)" fill="#fff" />
          <rect id="Rectángulo_141" data-name="Rectángulo 141" width="51" height="5.1"
            transform="translate(3.606 0) rotate(45)" fill="#fff" />
        </g>
      </g>
    </svg>
  </a> -->
  <div class="medal animate__slow animate__animated animate__slideInDown">
  </div>
  <div class="container-fluid modal-body centered">
    <div class="row">
      <div class="col-12">


        <div class="col-12" *ngFor="let t of trivias; let i = index" [hidden]="i!=current-1">
          <h3 *ngIf="isCorrect==true" class="text-center" style="color: white">Excelente</h3>
          <h3 *ngIf="isCorrect==false" class="text-center" style="color: white">Te equivocaste...</h3>

          <svg style="display: block;  margin: 20px auto;" xmlns="http://www.w3.org/2000/svg" width="140" height="140"
          viewBox="0 0 140 140">
          <g id="Grupo_98" data-name="Grupo 98" transform="translate(-140.83 -207.333)">
            <path id="Trazado_38" data-name="Trazado 38"
              d="M204.769,230.427c16.224,9.523,24.51,23.392,24.5,42.023l1.235.4,5.469-8.961c10.315,14.269,16.045,40.264-2.66,55.21a78.311,78.311,0,0,1-7.29,4.73c1.749-4.266,4.242-8.62,5.265-13.283,1.263-5.754-1.142-11.055-4.653-15.767-2.062-2.769-4.594-5.315-6.1-8.348-2.24-4.524-3.756-9.39-5.629-14.238-9.583,7.722-11.728,18.52-10.968,30.8-5.44-2.476-5.888-6.976-6.454-11.434-7.968,7.634-7.6,22.68.72,31.913-4.165-.617-10.169-5.027-14.03-10.307-8.675-11.862-8.667-27.688.215-40.6,2.856-4.154,6.092-8.063,9.222-12.036,6.448-8.185,10.252-17.3,10.425-27.729a8.521,8.521,0,0,1,.14-1.459C204.219,231.128,204.424,230.946,204.769,230.427Z"
              transform="translate(-0.797 0.204)" fill="#fff" />
            <g id="Grupo_89" data-name="Grupo 89" transform="translate(140.83 207.333)">
              <path id="Trazado_39" data-name="Trazado 39"
                d="M210.83,347.333a70,70,0,1,1,70-70A70.079,70.079,0,0,1,210.83,347.333Zm0-133.05a63.05,63.05,0,1,0,63.05,63.05A63.121,63.121,0,0,0,210.83,214.283Z"
                transform="translate(-140.83 -207.333)" fill="#fff" />
            </g>
          </g>
        </svg>

          <h4 *ngIf="isCorrect==true" class="game-modal-message hier-4" [innerHTML]="t.afirmative"></h4>
          <h4 *ngIf="isCorrect==false" class="game-modal-message hier-4" [innerHTML]="t.negative"></h4>
        </div>

        <div class="col-12">
          <a class="btn-theme ts-background-4 centered" (click)="modal.dismiss()">Continuar</a>
        </div>

      </div>
    </div>
  </div>
</ng-template>
